import React from 'react';
import styles from './BackButton.module.css';

const BackIcon = () => (
  <span className={styles.icon} aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 12H5M12 19l-7-7 7-7"
        stroke="currentColor"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

/**
 * Shared back/close navigation button with a consistent chevron icon.
 *
 * @param {object} props
 * @param {() => void} props.onClick
 * @param {string} [props.className] — Page-specific button styles (e.g. module `.backButton`)
 * @param {React.ReactNode} [props.children='Back']
 * @param {string} [props['aria-label']]
 */
const BackButton = ({
  onClick,
  className,
  children = 'Back',
  'aria-label': ariaLabel,
  type = 'button',
}) => (
  <button
    type={type}
    className={`${styles.root} ${className || ''}`}
    onClick={onClick}
    aria-label={ariaLabel ?? (typeof children === 'string' ? children : 'Go back')}
  >
    <BackIcon />
    {children != null && children !== false ? (
      <span className={styles.label}>{children}</span>
    ) : null}
  </button>
);

export default BackButton;
